const embedContainer = require("./embed-container");

module.exports = function videoComponent({ value }) {
  const { embedType, embedId, caption } = value;

  if (embedType === "youtube") {
    return embedContainer({
      content: `
        <iframe
          src="https://www.youtube.com/embed/${embedId}"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>`,
      type: "video",
      caption: caption
    });
  } else if (embedType === "vimeo") {
    return embedContainer({
      content: `
        <iframe
          src="https://player.vimeo.com/video/${embedId}"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen>
        </iframe>`,
      type: "video",
      caption: caption
    });
  }

  return ""; // Return empty string for unsupported types
};